export default __webpack_public_path__ + "static/ramanSharma7-ebbaffabfca727db4a27b7d083cf44b3.jpg";